export const pickConstants = {
    GET_PICKS_REQUEST: 'GET_PICKS_REQUEST',
    GET_PICKS_SUCCESS: 'GET_PICKS_SUCCESS',
    GET_PICKS_FAILURE: 'GET_PICKS_FAILURE',

    PUT_PICKS_REQUEST: 'PUT_PICKS_REQUEST',
    PUT_PICKS_SUCCESS: 'PUT_PICKS_SUCCESS',
    PUT_PICKS_FAILURE: 'PUT_PICKS_FAILURE'
};



// WEBPACK FOOTER //
// ./src/_constants/picks.js